import { render, staticRenderFns } from "./ViewLiquidReportOne.vue?vue&type=template&id=615e452a&scoped=true&"
import script from "./ViewLiquidReportOne.vue?vue&type=script&lang=js&"
export * from "./ViewLiquidReportOne.vue?vue&type=script&lang=js&"
import style0 from "./ViewLiquidReportOne.vue?vue&type=style&index=0&id=615e452a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615e452a",
  null
  
)

export default component.exports